import { useState } from 'react'
import { ISO_DATE_FORMAT, formatApiDate } from '~/shared/lib/date'
import { parseISO } from 'date-fns'
import { Box, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { getDueDateLabel } from '~/shared/lib/dateLabels'
import { FFInput } from '~/shared/ui'
import { mergeSx } from '~/shared/lib/mergeSx'

const NextActionDate = ({
  date,
  editable = false,
  onChange,
  newTodos = false,
  sx,
}: {
  date?: string | Date | null
  editable?: boolean
  onChange?: (value: string) => void
  newTodos?: boolean
  /**
   * Overrides for the default offsets, which exist to space the date from the
   * control preceding it in the flex rows this renders in (the Inbox table
   * cells and the To Do headers). A call site that positions the date itself —
   * a grid cell, say — passes `marginLeft: 0` to opt out.
   */
  sx?: SxProps<Theme>
}) => {
  const readableDate = date
    ? getDueDateLabel(typeof date === 'string' ? parseISO(date) : date, newTodos)
    : ''
  const [isEditable, setIsEditable] = useState(false)

  return (
    <Box
      sx={mergeSx(
        { marginLeft: '2.2rem', minWidth: '109px', cursor: editable ? 'pointer' : 'default' },
        sx,
      )}
      onClick={e => {
        e.stopPropagation()
        if (!editable) {
          return
        }

        setIsEditable(true)
      }}
    >
      <Typography component="span" style={{ fontSize: '1.4rem' }}>
        {isEditable ? (
          <FFInput
            size="small"
            onBlur={event => {
              onChange?.(event.target.value)
              setIsEditable(false)
            }}
            defaultValue={formatApiDate(date, ISO_DATE_FORMAT) ?? ''}
            type="date"
            placeholder="Next action date"
            slotProps={{
              input: {
                style: {
                  fontSize: 'inherit',
                },
                autoFocus: true,
              },
            }}
          />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            {readableDate || (editable ? 'Set date' : '')}
            {editable && !newTodos ? (
              <CalendarTodayIcon fontSize="inherit" sx={{ marginLeft: 1 }} />
            ) : null}
          </Box>
        )}
      </Typography>
    </Box>
  )
}

export default NextActionDate
